// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';
import previewImageHelper from '../../../helpers/previewImageHelper';
import setPlaceholderSelectBox from '../../../helpers/setPlaceholderSelectBox';
import maskInput from '../../../utils/maskInput';
import SearchAddressForm from '../../common/SearchAddressForm';
import ApproveWarningDialog from '../../common/ApproveWarningDialog';
import settingFormValidator from './settingFormValidator';

export const IDENTIFICATION_TYPES = [
  'driver_license',
  'passport',
  'resident_register',
  'my_number',
  'other',
];

export default class SettingFormView extends JQueryView {
  searchAddress = new SearchAddressForm('.setting-user-form');
  warningDialog = new ApproveWarningDialog('.setting-user-form');

  constructor() {
    super('.setting-user-form');
    this.render();
  }

  @on({ event: 'click', selector: '.upload-image, .upload-image-description' })
  chooseImage() {
    $('.choose-image').click();
  }

  @on({ event: 'change', selector: '.choose-image' })
  changeImage() {
    previewImageHelper($('.choose-image'), $('.upload-image'));
  }

  @on({ event: 'click', selector: '.approve-warning-action' })
  showApproveWarning(e: any) {
    e.preventDefault();
    e.stopPropagation();
    if (!this.$el.valid()) return;
    this.warningDialog.render(e.currentTarget);
  }

  @on({ event: 'click', selector: '.identification-type' })
  changeIdentificationType(e: any) {
    const identificationType = e.currentTarget.value;
    IDENTIFICATION_TYPES.filter(type => type !== identificationType).map(type =>
      $(`.${type}`).hide(),
    );
    $(`.${identificationType}`).show();
    if (identificationType === 'my_number') {
      $('#back_identification_photo').hide();
    } else {
      $('#back_identification_photo').show();
    }
  }

  @on({ event: 'change', selector: '.preview' })
  onChangeFrontBillPhoto(e: any) {
    this.readURL(e);
  }

  readURL(e: any) {
    let reader;
    if (e.target.files && e.target.files[0]) {
      reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = () => {
        $(e.target)
          .parent()
          .children('img')
          .attr('src', reader.result);
        $(e.target)
          .parent()
          .children('img')
          .show();
      };
    }
  }

  render() {
    maskInput();
    settingFormValidator();
    setPlaceholderSelectBox($('.search-prefecture'), '東京都');
  }
}
